export const applyFilterAcrossWorksheets = async ({
  worksheetTargets,
  tryApplyFilter,
  values
}) => {
  let appliedAny = false;
  let lastApplyError;

  for (const ws of worksheetTargets) {
    try {
      if (typeof ws?.applyFilterAsync === 'function') {
        const wasApplied = await tryApplyFilter(ws, values);
        appliedAny = appliedAny || wasApplied;
      }
    } catch (error) {
      // A worksheet may not contain the requested field; continue fan-out.
      lastApplyError = error;
    }
  }

  if (!appliedAny) {
    throw lastApplyError || new Error('No worksheet accepted filter apply.');
  }
};

export const clearFilterAcrossWorksheets = async ({
  worksheetTargets,
  tryClearFilter
}) => {
  let clearedAny = false;
  let lastClearError;

  for (const ws of worksheetTargets) {
    try {
      if (typeof ws?.clearFilterAsync === 'function') {
        const wasCleared = await tryClearFilter(ws);
        clearedAny = clearedAny || wasCleared;
      }
    } catch (error) {
      // A worksheet may not contain the requested field; continue fan-out.
      lastClearError = error;
    }
  }

  if (!clearedAny) {
    throw lastClearError || new Error('No worksheet accepted filter clear.');
  }
};

export const ensureActiveSheetCanClear = (activeSheet) => {
  if (typeof activeSheet?.clearFilterAsync !== 'function') {
    throw new Error('No Tableau sheet supports clearFilterAsync for runtime filter clear.');
  }
};

export const ensureActiveSheetCanApply = (activeSheet) => {
  if (typeof activeSheet?.applyFilterAsync !== 'function') {
    throw new Error('No Tableau sheet supports applyFilterAsync for runtime filter apply.');
  }
};
